import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./page-heading.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./page-heading.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { RouterParamsService } from "../../services/route-params.service";
import { UserInformationService } from "../../services/user/user-information.service";
import { filter } from "rxjs/operators";
import { AppControllerService } from "../../../app-controller.service";
import { SubscriberComponent } from "../subscriber/subscriber.component";
export let PageHeadingComponent = class PageHeadingComponent extends SubscriberComponent {
    routerParamsService;
    appController;
    changeDetectorRef;
    userInformationService;
    title;
    heading;
    subheading;
    moduleHeading;
    organisationHeading;
    currentModule;
    currentOrganisation;
    constructor(routerParamsService, appController, changeDetectorRef, userInformationService) {
        super();
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.changeDetectorRef = changeDetectorRef;
        this.userInformationService = userInformationService;
    }
    ngOnInit() {
        this.listenForRouteParamChanges();
        this.setModuleHeadings();
    }
    listenForRouteParamChanges() {
        const onlyValidParams = this.routerParamsService.params.pipe(filter(param => param.moduleid || param.organisationid));
        this.cleanupAfterDestroy(onlyValidParams).subscribe((params) => {
            if (params) {
                if (params.moduleid) {
                    this.cleanupAfterDestroy(this.userInformationService.$systemModules).subscribe((modules) => {
                        if (modules !== undefined && modules !== null && modules.length > 0) {
                            this.currentModule = this.userInformationService.getModuleInformation(+params.moduleid);
                            this.setModuleHeadings();
                        }
                    });
                }
            }
        });
    }
    setModuleHeadings() {
        if (this.currentModule) {
            this.moduleHeading = this.currentModule.name;
            this.organisationHeading = this.currentModule.organisation?.name;
            this.changeDetectorRef.markForCheck();
        }
    }
    static ctorParameters = () => [
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: UserInformationService }
    ];
    static propDecorators = {
        title: [{ type: Input }],
        heading: [{ type: Input }],
        subheading: [{ type: Input }]
    };
};
PageHeadingComponent = __decorate([
    Component({
        selector: "app-page-heading[heading]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], PageHeadingComponent);
